__turbopack_context__.v({
  "container": "TabbedContent-module__u9Ztiq__container",
  "navLink": "TabbedContent-module__u9Ztiq__navLink",
  "navLinkActive": "TabbedContent-module__u9Ztiq__navLinkActive",
  "navTabs": "TabbedContent-module__u9Ztiq__navTabs",
  "tabContent": "TabbedContent-module__u9Ztiq__tabContent",
  "tabContentNoPadding": "TabbedContent-module__u9Ztiq__tabContentNoPadding",
});
